<!--
 * @Date: 2019-10-09 14:38:10
 * @LastEditors: liu yu
 * @LastEditTime: 2019-10-09 16:35:03
 -->
<template>
  <div class="xes-slide-confirm">
    <i class="xes-slide-confirm__close" @click="close"></i>
    <p class="xes-slide-confirm-title">帐号安全验证</p>
    <div class="xes-slide-confirm-captcha">
      <div id="captcha"></div>
    </div>
  </div>
</template>
<script>
export default {
  mounted() {
    this.$nextTick(() => {
      this.$xesTalLogin.captcha('#captcha')
    })
  },
  methods: {
    // 关闭弹框
    close() {
      this.$emit('close')
    }
  }
}
</script>

<style lang="less">
.xes-slide-confirm {
  position: relative;
  width: 300px;
  height: 168px;
  padding: 20px 0;
  overflow: hidden;
  background: #fff;
  border-radius: 6px;

  // 关闭按钮
  &__close {
    position: absolute;
    top: 18px;
    right: 18px;
    display: inline-block;
    width: 22px;
    height: 22px;
    background: url('./images/icon-close.svg') no-repeat;
    background-size: 100%;
  }

  // 左上角标题
  &-title {
    font-size: 16px;
    font-weight: 500;
    line-height: 24px;
    text-align: center;
    color: rgba(33, 40, 50, 1);
  }

  &-captcha {
    padding-top: 40px;
  }

  // 滑块部分
  #__nc {
    padding-top: 42px;
    margin: 0 auto;
  }

  /* 滑动条高度、边框、背景色等 */
  ._nc .stage1 .slider {
    height: 48px;
    margin: 0 7px;
    background: rgba(245, 245, 245, 1);
    border-radius: 24px;
    box-shadow: 0 0 3px rgba(245, 245, 245, 1);

    .label {
      height: 42px;
      font-size: 13px;
      font-weight: 400;
      font-family: PingFangSC-Regular;
      line-height: 48px;
      color: #212832;
    }

    .track {
      height: 48px;

      .bg-green {
        height: 48px;
        background: rgba(51, 195, 180, 1);
      }

      .bg-red {
        height: 48px;
      }
    }

    .button {
      width: 48px;
      height: 48px;
      padding-top: 0.01rem;
      border-radius: 50%;

      .icon {
        top: 50%;
        bottom: auto !important;
        left: 50%;
        width: 48px;
        height: 48px;
        text-align: center;
        color: transparent;
        border-radius: 50%;
        box-shadow: 1px 0.03rem 0.01rem rgb(221, 219, 219);
        transform: translate(-50%, -50%);
      }

      .icon-slide-arrow::before {
        display: inline-block;
        width: 44px;
        height: 44px;
        margin-left: 0.05rem;
        margin-top: 0.05rem;
        background-image: url('./images/icon-right-arrow.svg');
        background-position: center;
        background-size: 44px 44px;
        background-repeat: no-repeat;
        content: '';
      }

      .icon-ok {
        display: inline-block;
        width: 48px;
        height: 48px;
        background-image: url('./images/icon-success.svg');
        background-position: center;
        background-size: 44px 44px;
        background-repeat: no-repeat;
        box-shadow: 1px 0.03rem 0.01rem rgb(221, 219, 219);
        content: '';
      }

      .icon-ok::before {
        display: none;
        content: '';
      }

      .icon-close::before {
        display: inline-block;
        vertical-align: middle;
      }
    }
  }

  .nc-loading {
    width: 26px !important;
    height: 26px !important;
    margin-left: -13px !important;
    margin-top: -13px !important;
    background-image: url('./images/loading.svg');
    background-position: center;
    background-size: 26px 26px !important;
    background-repeat: no-repeat;
    box-shadow: none !important;
    animation: rotate 1s linear infinite;

    &::before {
      display: none;
    }
  }

  ._nc .icon {
    width: 44px;
    height: 44px;
  }

  /* 滑动条 */
  ._nc .stage1 .track div {
    color: #fff;
    border-radius: 24px;
  }

  /* 滑动条背景色-正常 */
  ._nc .stage1 {
    .bg-green {
      background-color: #78c430;
    }
  }

  /* 滑动条背景色-失败 */
  ._nc .stage1 .bg-red {
    background-color: #f50;
  }

  .nc-h5-overlay div.info i.iconfont {
    width: 6px;
    margin-right: 1px;
    font-size: 120%;
    color: #f00;
  }

  /* 验证码输入框 */
  ._nc .stage2 .textbox .input {
    left: 10px;
    width: 140px;
    height: 40px;
    font-size: 18px;
    color: #333;
    background: none;
    outline: none;
  }

  ._nc .stage2 .textbox .placeholder {
    left: 12px;
    line-height: 28px;
  }

  ._nc .stage2 .textbox .code {
    right: 30px;
  }

  ._nc .stage2 .icon.tip {
    display: none;
  }

  ._nc .stage2 .icon.clear {
    left: 106px;
    background-position: -224px 0;
  }

  ._nc .stage2 .icon.refresh {
    top: 11px !important;
    right: 2px;
    background-position: -256px 0;
  }

  /* 确定按钮、提示 */
  ._nc .stage2 .btn-ok,
  ._nc .stage2 .tips {
    width: 100%;
    height: 46px;
    font-size: 20px;
    color: #fff;
    background-color: #3199f4;
    border: none;
    border-radius: 5px;
    outline: none;
  }

  ._nc .stage2 .btn-ok:disabled {
    background-color: #ccc;
  }

  ._nc .stage2 .tips {
    line-height: 46px;
    text-align: center;
    color: #fff;
    background-color: #333;
  }

  ._nc .stage2 .ope .tips {
    font-size: 16px;
  }

  ._nc .stage3 {
    height: auto;
    padding-bottom: 45px;
    margin: -30px 0 0 0;

    .title {
      padding: 3px 0 8px 0;
      margin: 0 !important;
      font-size: 16px;
    }

    .menu {
      width: 90%;
      height: 48px;
      line-height: 61px;
      background: rgba(250, 250, 250, 1);
      border-radius: 32px;

      &::after {
        display: block;
        width: 50px;
        height: 50px;
        content: '';
      }
    }

    .menu.nc-sep {
      display: none !important;
    }
  }

  ._nc .stage3 .menu.feedback {
    display: none !important;
  }

  ._nc .stage3 .menu .icon {
    width: 22px;
    height: 22px;
    margin: 0 0 2px 0;
    background-image: url('./images/icon-reload.svg');
    background-position: center;
    background-size: 22px 22px;
    background-repeat: no-repeat;

    &::before {
      display: none;
    }
  }

  ._nc .stage3 .menu .label {
    font-size: 16px;
    font-weight: 400;
    font-family: PingFangSC-Regular;
    color: rgba(255, 94, 80, 1);
  }
}

@keyframes rotate {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}
</style>
